export const IS_LOADING = "IS_LOADING";
export const CLIENT_DATA_SUCCESS = "CLIENT_DATA_SUCCESS";
export const CLIENT_DATA_FAILED = "CLIENT_DATA_FAILED";
export const CLIENT_DATA_STORE_FAILED = "CLIENT_DATA_STORE_FAILED";
export const CLIENT_DATA_STORE_SUCCESS = "CLIENT_DATA_STORE_SUCCESS";

export const CLIENT_TOOGLER_SUCCESS = "CLIENT_TOOGLER_SUCCESS";
export const CLIENT_TOOGLER_LEAVE_SUCCESS = "CLIENT_TOOGLER_LEAVE_SUCCESS";